module.exports = __webpack_public_path__ + "media/images/sp/stores/karuizawa/karuizawa_concept_01-002d25b26b2079eda4291341eb649094.jpg";